import React from 'react'
import { Card, Row, Col, CardBody, } from 'reactstrap'
import AssessDashCircle from '../AssessDashCircle';
import AssessDashStartOrResume from '../AssessDashStartOrResume';
import { getAssessSelectorNavLinks } from '../../../helpers/assessment/assessmentDashboard';
import AssessSelectorNav from '../AssessSelectorNav';

// A subtest card that is displayed on the dashboard when
// a student's subtest hasn't been completed yet.
export default function IncompleteSubtestCard ({
  title,
  subtest,
  resume,
  userAssessmentId,
  groupUAId,
  isStudent,
  groupUA,
  selectedStudent,
  userAssessment,
  previousTest,
  year,
  licenseExpired,
}) {
  return (
    <Card className='start-card assessment-overview-by-subject rounded-top'>
      <Row className='assessment-overview-by-subject__title-container rounded-top' noGutters>
        <Col xs='12'>
          <h3 className='title'>{title}</h3>
        </Col>
      </Row>
      <CardBody>
        <Row>
          <Col xs='12'>
            <AssessDashCircle
              score={0}
              subject={subtest ? subtest.displayName : ''}
            />
          </Col>
        </Row>
        <AssessDashStartOrResume
          subtest={subtest}
          resume={resume}
          userAssessmentId={userAssessmentId}
          groupUAId={groupUAId}
          sub={true}
          isStudent={isStudent}
          groupUA={groupUA}
          userAssessment={userAssessment}
          previousTest={previousTest}
          year={year}
          selectedStudent = {selectedStudent}
          licenseExpired={licenseExpired}
        />
      </CardBody>
    </Card>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessDash/IncompleteSubtestCard.js